import request from '@/utils/request'
const BASE_URL = '/Analysis'

export default {
  getMonitorAnalysis(data) {
    return request({
      url: BASE_URL + '/GetMonitorAnalysis',
      method: 'post',
      data
    })
  },
  getRecent7DaysTop5WorkHours() {
    return request({
      url: BASE_URL + '/GetRecent7DaysTop5WorkHours',
      method: 'get'
    })
  },
  getRecent7DaysWorkHoursTrend() {
    return request({
      url: BASE_URL + '/GetRecent7DaysWorkHoursTrend',
      method: 'get'
    })
  }
}
